import React from 'react';

export default function AccordionSection({
  id,
  title,
  subtitle,
  isOpen,
  onToggle,
  children,
}) {
  return (
    <section
      className={`natal-accordion${
        isOpen ? ' is-open' : ''
      }`}
    >
      <button
        type="button"
        className="natal-accordion-trigger"
        onClick={onToggle}
        aria-expanded={Boolean(isOpen)}
        aria-controls={`acc-${id}`}
      >
        <span className="natal-accordion-copy">
          <strong>{title}</strong>

          {subtitle ? (
            <small>{subtitle}</small>
          ) : null}
        </span>

        <span
          className="natal-accordion-chevron"
          aria-hidden="true"
        >
          ›
        </span>
      </button>

      {isOpen ? (
        <div
          id={`acc-${id}`}
          className="natal-accordion-content"
        >
          {children}
        </div>
      ) : null}
    </section>
  );
}
